import { MdOutlineImage, MdOutlineVisibility } from 'react-icons/md';
import type { CommunityPost } from './BoardTypes';

type Props = {
  post: CommunityPost;
  imageUri?: string;
  dateLabel: string;
  isNotice: boolean;
  onOpenDetail: () => void;
};

export default function BoardImageListItem({
  post,
  imageUri,
  dateLabel,
  isNotice,
  onOpenDetail,
}: Props) {
  return (
    <div
      className={isNotice ? 'board-image-item board-image-item--notice' : 'board-image-item'}
      onClick={onOpenDetail}
      onKeyDown={(e) => {
        if (e.key === 'Enter') onOpenDetail();
      }}
      role="button"
      tabIndex={0}
    >
      <div className="board-image-item__image">
        {imageUri ? (
          <img src={imageUri} alt="" />
        ) : (
          <div className="board-image-item__placeholder">
            <MdOutlineImage size={26} />
          </div>
        )}
      </div>
      <div className="board-image-item__body">
        <div className="board-image-item__top">
          <span className="board-image-item__badge">{post.sort}</span>
          <p className="board-image-item__title">
            {post.title}
            {post.commentCount ? (
              <span className="community-board__comment"> [{post.commentCount}]</span>
            ) : null}
          </p>
        </div>
        <div className="board-image-item__meta">
          <span>{post.userNickName}</span>
          <span className="board-image-item__dot">·</span>
          <span>{dateLabel}</span>
          <span className="board-image-item__views">
            <MdOutlineVisibility />
            {post.views}
          </span>
        </div>
      </div>
    </div>
  );
}
